(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mm-discovery-tracking"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.__mmDiscoveryTracking) return;
  window.__mmDiscoveryTracking = true;
  const measurementId = 'G-8VRX1Q1BFN';
  const videoStarts = new WeakSet();
  const videoCompletions = new WeakSet();

  function isPreview() {
    return Boolean(window.Shopify?.designMode) ||
      new URLSearchParams(location.search).has('preview_theme_id') ||
      Boolean(document.querySelector('#PBarNextFrame, #shopify-preview-bar-iframe'));
  }

  function send(name, parameters) {
    try {
      if (isPreview() || typeof window.gtag !== 'function') return false;
      const privacy = window.Shopify?.customerPrivacy;
      if (!privacy || privacy.analyticsProcessingAllowed() !== true) return false;
      window.gtag('event', name, {
        send_to: measurementId,
        transport_type: 'beacon',
        ...parameters
      });
      return true;
    } catch (error) {
      return false;
    }
  }

  if (window.Shopify?.loadFeatures && !window.Shopify.customerPrivacy) {
    try {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], () => {});
    } catch (error) {}
  }

  document.addEventListener('click', (event) => {
    if (!event.isTrusted || !(event.target instanceof Element)) return;
    const anchor = event.target.closest('a[href]');
    if (!anchor) return;
    let placement;
    if (anchor.closest('#mm-trial')) placement = 'trial_landing';
    else if (anchor.closest('#mm-wholesale')) placement = 'wholesale';
    else if (anchor.closest('#mm-sweet')) placement = 'sweet_matcha';
    else if (anchor.closest('.mc-collections')) placement = 'home_collections';
    else if (anchor.closest('.mv-entry')) placement = 'home_trial';
    else return;
    const destination = new URL(anchor.href, location.origin);
    if (destination.origin !== location.origin) return;
    const variant = destination.searchParams.get('variant');
    send('mm_discovery_click', {
      placement,
      cta_id: anchor.dataset.mmAction || placement,
      destination_path: destination.pathname,
      destination_section: destination.hash.replace('#', ''),
      ...(variant && /^\d+$/.test(variant) ? { variant_id: variant } : {})
    });
  });

  document.addEventListener('play', (event) => {
    const video = event.target;
    if (!(video instanceof HTMLVideoElement) || !video.matches('[data-mm-video="trial-colors"]') || videoStarts.has(video)) return;
    if (send('mm_trial_video_start', { placement: video.closest('#mm-trial-product') ? 'trial_product' : 'trial_landing' })) videoStarts.add(video);
  }, true);

  document.addEventListener('ended', (event) => {
    const video = event.target;
    if (!(video instanceof HTMLVideoElement) || !video.matches('[data-mm-video="trial-colors"]') || videoCompletions.has(video)) return;
    if (send('mm_trial_video_complete', { placement: video.closest('#mm-trial-product') ? 'trial_product' : 'trial_landing' })) videoCompletions.add(video);
  }, true);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mm-purchase-summary"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mm-purchase-summary')) {
    customElements.define('mm-purchase-summary', class extends HTMLElement {
      connectedCallback() {
        if (typeof subscribe !== 'function' || this.unsubscribeVariant) return;
        this.unsubscribeVariant = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
          if (String(data.sectionId) !== this.dataset.section) return;
          const source = data.html.getElementById(this.id)?.querySelector('[data-mm-pack-facts]');
          const destination = this.querySelector('[data-mm-pack-facts]');
          if (!source || !destination) return;
          destination.innerHTML = source.innerHTML;
        });
      }
      disconnectedCallback() {
        this.unsubscribeVariant?.();
        this.unsubscribeVariant = null;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mm-quote-runtime"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.__mmQuoteReady) return;
  window.__mmQuoteReady = true;
  const placements = new Set(['product','cart','trial','wholesale','index','collection','floating','about','quality','yame','faq','menu']);
  function track(name, placement) {
    try {
      if (window.Shopify?.designMode || new URLSearchParams(location.search).has('preview_theme_id') || document.querySelector('#PBarNextFrame, #shopify-preview-bar-iframe')) return;
      if (typeof window.gtag !== 'function' || window.Shopify?.customerPrivacy?.analyticsProcessingAllowed() !== true) return;
      window.gtag('event', name, {send_to:'G-8VRX1Q1BFN',transport_type:'beacon',placement:placements.has(placement)?placement:'general'});
    } catch (error) {}
  }
  function prepare() {
    const trialSlot = document.querySelector('[data-mm-trial-quote]');
    const trialOffer = document.querySelector('#mm-trial .mm-hero-offer');
    if (trialSlot && trialOffer && trialSlot.parentElement !== trialOffer) trialOffer.append(trialSlot);
    const form = document.getElementById('ContactForm');
    if (!form?.matches('[data-mm-quote-form]') || form.dataset.mmReady) return;
    form.dataset.mmReady = 'true';
    const params = new URLSearchParams(location.search);
    const order = form.querySelector('[data-mm-order]');
    const source = form.querySelector('[data-mm-source]');
    const placement = params.get('quote') || 'general';
    if (source) source.value = placements.has(placement) ? placement : 'general';
    if (order && !order.value.trim()) {
      const item = (params.get('item') || '').slice(0,1000);
      const size = (params.get('size') || '').slice(0,500);
      const qty = Math.max(1, Math.min(100000, Number.parseInt(params.get('qty') || '1',10) || 1));
      if (item) order.value = [item, size && size !== 'Default Title' ? size : '', '× ' + qty].filter(Boolean).join(' · ');
      else if (placement === 'cart') order.value = form.querySelector('[data-mm-cart-order]')?.content?.textContent.trim() || '';
    }
    if (form.querySelector('[data-mm-quote-success]')) {
      try {
        const key = 'mm_quote_success:' + location.pathname + location.search;
        if (!sessionStorage.getItem(key)) {track('mm_quote_submit', placement);sessionStorage.setItem(key,'1');}
      } catch (error) {}
    }
  }
  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    const anchor = event.target.closest('a[data-mm-quote], .header__inline-menu a[href*="quote=menu"], .menu-drawer a[href*="quote=menu"]');
    if (!anchor) return;
    let source = anchor;
    if (anchor.dataset.mmQuote === 'floating') {
      const productLink = document.querySelector('a[data-mm-product-id]');
      if (productLink) source = productLink;
    }
    const destination = new URL(source.href, location.origin);
    if (destination.origin !== location.origin) return;
    if (source.dataset.mmProductTitle) {
      const container = source.closest('product-info') || document.querySelector('product-info');
      const variantId = container?.querySelector('form[action*="/cart/add"] input[name="id"]')?.value;
      const quantity = container?.querySelector('input[name="quantity"]')?.value || '1';
      try {
        const variants = JSON.parse(source.dataset.mmVariants || '[]');
        const variant = variants.find(item => String(item.id) === String(variantId));
        if (variant) destination.searchParams.set('size', variant.title);
      } catch (error) {}
      destination.searchParams.set('item',source.dataset.mmProductTitle);
      destination.searchParams.set('qty',String(Math.max(1,Number.parseInt(quantity,10)||1)));
    }
    anchor.href = destination.href;
    if (event.isTrusted) track('mm_quote_click', anchor.dataset.mmQuote || destination.searchParams.get('quote'));
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',prepare,{once:true});
  else prepare();
  document.addEventListener('shopify:section:load',prepare);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["price"] && !Shopify.designMode) return;
  try {
    (() => {
  let pending = false;
  const expireKgOffer = () => {
    document.querySelectorAll('.price[data-mm-kg-end]').forEach(price => {
      if (Date.now() < Date.parse(price.dataset.mmKgEnd)) return;
      const originalMoney = price.dataset.mmKgOriginal;
      price.querySelectorAll('.price__regular .price-item, .price__sale .price-item--sale').forEach(node => {
        if (originalMoney && node.textContent !== originalMoney) node.textContent = originalMoney;
      });
      price.classList.remove('mm-campaign-price', 'price--on-sale', 'volume-pricing--sale-badge');
      price.querySelectorAll('[data-mm-kg-note]').forEach(node => node.remove());
      price.removeAttribute('data-mm-kg-end');
      price.removeAttribute('data-mm-kg-original');
      price.removeAttribute('data-mm-sticky-caption');
    });
  };
  const syncSalePrice = () => {
    pending = false;
    expireKgOffer();
    const price = document.querySelector('product-info[id^="MainProduct"] [id^="price-"] .mm-campaign-price');
    const saleText = price?.querySelector('.price-item--sale')?.textContent.trim();
    document.querySelectorAll('.Vtl-StickyAddToCart__ProductPrice').forEach(container => {
      let display = container.querySelector('.mm-campaign-sticky-price');
      if (saleText) {
        if (!display) {
          display = document.createElement('span');
          display.className = 'mm-campaign-sticky-price';
          const amount = document.createElement('span');
          amount.className = 'mm-campaign-sticky-price__amount';
          display.appendChild(amount);
          container.appendChild(display);
        }
        const label = price.querySelector('.price__badge-sale')?.textContent.trim() || '';
        const amount = display.querySelector('.mm-campaign-sticky-price__amount');
        const text = label + ' · ' + saleText;
        if (amount && amount.textContent !== text) amount.textContent = text;
        let note = display.querySelector('.mm-campaign-sticky-price__note');
        const caption = price.dataset.mmStickyCaption || '';
        if (caption) {
          if (!note) {
            note = document.createElement('small');
            note.className = 'mm-campaign-sticky-price__note';
            display.appendChild(note);
          }
          if (note.textContent !== caption) note.textContent = caption;
        } else {
          note?.remove();
        }
        if (!container.hasAttribute('data-mm-sale-price')) container.setAttribute('data-mm-sale-price', '');
      } else {
        display?.remove();
        container.removeAttribute('data-mm-sale-price');
      }
    });
  };
  const queueSync = () => {
    if (pending) return;
    pending = true;
    requestAnimationFrame(syncSalePrice);
  };
  const start = () => {
    syncSalePrice();
    new MutationObserver(queueSync).observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });
    setInterval(queueSync, 15000);
    window.addEventListener('pageshow', queueSync);
    document.addEventListener('visibilitychange', queueSync);
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, {once: true});
  } else {
    start();
  }
})();
  } catch(e) { console.error(e); }
})();

})();
